import React from "react";
import CheckoutForm from "../../Components/Forms/CheckoutForm/CheckoutForm";

const CheckoutPage = () => {
  return (
    <>
      <CheckoutForm />
    </>
  );
};

export default CheckoutPage;
